import DownloadIcon from 'icons/download'
// import { useCardHolders } from 'layouts/admin/team/team.context'
import { useCardHolders } from 'layouts/admin/cardholder/card-holders.context'
import React from 'react'
import { useIntl } from 'react-intl'

function DownloadList() {
  const { formatMessage } = useIntl()
  const { downloadExcel   } = useCardHolders()
  
  return (
    <div
      onClick={()=>downloadExcel()}
      class='tw-flex tw-cursor-pointer  tw-text-regular tw-items-center  hover:tw-text-electricGreen tw-gap-[5px] tw-px-[18px] lg:tw-flex'
    >
      <DownloadIcon />
      <span class='tw-text-regular tw-flex tw-items-center '>
        {formatMessage({ id: 'Download list (.xlsx)' })}
      </span>
    </div>
  )
}

export default DownloadList
